import type { ReactNode } from 'react';
import React from 'react';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Modal } from 'Components/frameworks/modal/Modal';
import { t } from 'Src/i18n';
type Props = {
  imageUrl: string;
  icon: string;
  onClose: () => void;
  children: ReactNode;
};
export const ModalWithImageIcon = ({ imageUrl, icon, onClose, children }: Props) => {
  return (
    <Modal closeLabel={t('common.close')} onClose={onClose}>
      <div className="overflow-hidden">
        <div
          className="left-0 top-0 -z-1 flex h-228 w-full items-center justify-center bg-cover bg-center bg-no-repeat"
          data-testid="Modal-backgroundImage"
          style={{
            backgroundImage: `url(${imageUrl})`,
          }}
        >
          <Icon className="text-white" dataTestid="Modal-icon" name={icon} width="7em" />
        </div>

        {children}
      </div>
    </Modal>
  );
};
